module.exports = __webpack_public_path__ + "static/media/menu-items.cd8fe6da.svg";